/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { api, HttpRequestI } from '../../services';

const name = 'StateListSegments';

export interface ISegments {
  idMarketplace: any;
  idCategoria: any;
  dsCategoria: string;
  dsImagem: string;
  nrOrdem: any;
}

interface IResponse {
  data: [];
  headers: [] | any;
  selected: ISegments;
}

interface IMessageResponse {
  headers: any;
  data: any;
}

type StateType = IResponse & {
  httprequest?: Partial<HttpRequestI>;
};

const initialState: StateType = {
  data: [],
  headers: [],
  selected: {} as ISegments,
  httprequest: { error: false, loading: false, success: false },
};

const searchListSegments = createAsyncThunk(
  `${name}/LIST_SEGMENTS`,
  async (state?: Partial<any>, agrsThunk?: any) => {
    try {
      const result =
        await api.apiMaisdelivery.shop.indexSegments<IMessageResponse>({
          nr_operacao: state?.nr_operacao,
          dsCidade: state?.dsCidade,
        });
      return result;
    } catch (error) {
      return agrsThunk.rejectWithValue(error);
    }
  },
);

const ListSegments = createSlice({
  name,
  initialState,
  reducers: {
    selected: (state, action: PayloadAction<number>) => {
      const result = state.data.find(
        (segments: any) =>
          Number(segments.idCategoria) === Number(action.payload),
      );
      if (Boolean(result) === true) {
        localStorage.setItem(
          '@mais/delivery/segments/selected',
          JSON.stringify(result),
        );
      }

      return { ...state, result };
    },
    ParamsUrl: (state, action: PayloadAction<any>) => {
      return { ...state, params: action.payload };
    },
  },
  extraReducers: (build) => {
    build.addCase(searchListSegments.pending, (state) => {
      return {
        ...state,
        httprequest: {
          loading: true,
          error: false,
          success: false,
        },
      };
    });
    build.addCase(
      searchListSegments.fulfilled,
      (state, action: PayloadAction<IResponse[] | any>) => {
        return {
          ...state,
          data: action.payload.data,
          headers: action.payload.headers,
          httprequest: {
            error: false,
            loading: false,
            success: true,
          },
        };
      },
    );
    build.addCase(
      searchListSegments.rejected,
      (state, action: PayloadAction<any>) => {
        return {
          ...state,
          httprequest: {
            error: true,
            loading: false,
            success: false,
            errorMsg: action.payload,
          },
        };
      },
    );
  },
});

export const reducerListSegments = ListSegments.reducer;
export const actionListSegments = {
  ...ListSegments.actions,
  searchListSegments,
};
